import api, { getFreshCsrfToken } from "./api";

export const AUTH_LOGOUT_EVENT = "auth:logout";

interface LoginResponse {
  message: string;
  user: {
    username: string;
    email: string;
  };
  access?: string;
  refresh?: string;
}

export const login = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    // Get a fresh CSRF token before making the login request
    await getFreshCsrfToken();

    const response = await api.post("/auth/login/", {
      email,
      password,
    });

    // Update CSRF token from login response if provided
    if (response.data.csrfToken) {
      api.defaults.headers.common['X-CSRFTOKEN'] = response.data.csrfToken;
    }

    // Also check for CSRF token in response headers
    const headerToken = response.headers['x-csrftoken'];
    if (headerToken) {
      api.defaults.headers.common['X-CSRFTOKEN'] = headerToken;
    }

    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const logout = async (): Promise<void> => {
  try {
    // Get a fresh CSRF token before making the logout request
    await getFreshCsrfToken();

    // The Authorization header should already be set from login if the user is logged in
    // Make sure we keep it for the logout request so the backend can identify the session
    await api.post("/auth/logout/");
    window.dispatchEvent(new Event(AUTH_LOGOUT_EVENT));
  } catch (error) {
    console.error('Logout error:', error);
    throw error;
  } finally {
    // Always clear local auth state so the UI can move to login.
    delete api.defaults.headers.common['X-CSRFTOKEN'];
    delete api.defaults.headers.common['Authorization'];

    // Clear the bearer token, refresh token, and CSRF cookies
    document.cookie = 'csrftoken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
  }
};



//interecpt 401 errors and logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);